/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { VersionHistoryEntrySourceVersion } from './versionHistoryEntrySourceVersion';
import type { IdReference } from './idReference';
import type { ModuleVersionState } from './moduleVersionState';

/**
 * Represents a single entry in the version history of a module
 */
export interface VersionHistoryEntry {
  version: string;
  sourceVersion?: VersionHistoryEntrySourceVersion;
  createdAt: string;
  createdBy: IdReference;
  changelog?: string;
  workflowState?: ModuleVersionState;
}
